<template>
  <div ref="scrollToDownRef" class="pb-20">
    <div v-if="messages.length">
      <!-- C A R D -->
      <DiscussionChatMessage
        v-for="(message, index) in messages"
        :key="message.id"
        :message="message"
        :last-message="index === messages.length - 1"
        :discussion="discussion"
        class="mt-10 md:mt-20 min-h-100"
        @editMessage="editMessage"
      />
    </div>

    <div class="-mx-15 md:mx-0 flex mt-20">
      <div class="hidden md:flex flex-col flex-shrink-0 text-grey-300 text-15 pr-25 w-150">
        <div class="text-app-color flex items-center rounded-6 py-3 px-10 ml-auto max-w-125"
             :class="isDarkMode ? 'bg-book' : 'bg-white shadow-user-badge border border-grey-500'"
        >
          <UserBadge
            :first-name="user.profile.firstName"
            :last-name="user.profile.lastName"
            :color="user.profile.color"
            color-height="h-18"
            max-width="max-w-95"
          />
        </div>
        <p class="text-13 text-grey-250 text-right">now</p>
      </div>
      <DiscussionChatEditor
        ref="discussionChatEditorRef"
        :discussion="discussion"
        :allow-hot-key="allowHotKey"
        @scroll-to-down="scrollToElement"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted, nextTick } from 'vue'

import { useStore } from 'vuex'
import DiscussionChatMessage from '@/components/discussions/DiscussionChatMessage'
import DiscussionChatEditor from '@/components/discussions/DiscussionChatEditor'
import UserBadge from '@/components/shared/UserBadge'

export default defineComponent({
  components: {
    DiscussionChatMessage,
    DiscussionChatEditor,
    UserBadge
  },

  props: {
    discussion: Object,
    allowHotKey: Boolean
  },

  setup (props, { emit }) {
    const { state, getters } = useStore()

    const user = computed(() => state.profile.user)
    const discussionChatEditorRef = ref(null)

    const scrollToDownRef = ref(null)

    const messages = computed(() => state.discussions.messages)
    const countMessages = computed(() => props.discussion.discussionMessages?.length || 0)

    const isDarkMode = computed(() => getters.isDarkMode)

    const messageCount = computed(() => messages.value.length)

    onMounted(async () => {
      scrollToElement()
    })

    function scrollToElement () {
      nextTick(() => {
        if (scrollToDownRef.value) {
          scrollToDownRef.value.scrollTop = scrollToDownRef.value.scrollHeight
        }
      })
    }

    function editMessage (value) {
      discussionChatEditorRef.value.editMessage(value)
      scrollToDownRef.value.scrollIntoView({ block: 'end', behavior: 'smooth' })
    }

    return {
      // refs
      scrollToDownRef,
      discussionChatEditorRef,
      // data
      messages,
      // computed
      user,
      isDarkMode,
      messageCount,
      countMessages,
      // function
      close,
      editMessage,
      scrollToElement
    }
  }
})
</script>
